function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M93.8543 26.1565C92.2903 24.6145 89.7546 24.6145 88.1906 26.1565C86.6267 27.6985 86.6267 30.1986 88.1906 31.7406L111.265 54.4913L88.173 77.2594C86.609 78.8014 86.609 81.3015 88.173 82.8435C89.737 84.3855 92.2726 84.3855 93.8366 82.8435L116.929 60.0754L139.163 81.9977C140.727 83.5397 143.263 83.5397 144.827 81.9977C146.391 80.4556 146.391 77.9556 144.827 76.4136L122.593 54.4913L144.809 32.5865C146.373 31.0445 146.373 28.5444 144.809 27.0023C143.245 25.4603 140.71 25.4603 139.146 27.0023L116.929 48.9072L93.8543 26.1565Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3726 79H15C6.71573 79 0 72.2843 0 64V46C0 37.7157 6.71573 31 15 31H38.3726L74.5 0.440399L74.5 109.56L38.3726 79Z"
});

function SvgAudioOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 110,
    viewBox: "0 0 146 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio_off.9f04e1a8.svg";
export { ForwardRef as ReactComponent };